import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export class HttpErrorInterceptor implements HttpInterceptor {
  constructor() {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          let errorMessage = {
            detail: 'Too many requests or Unknown Error, Please try again later',
            code: 0
          };
          if (error.error instanceof Blob && error.error.type === 'application/json') {
            return this.handleBlobError(error.error);
          }
          if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage.detail = `Error: ${error.error.message}`;
          } else {
            // server-side error
            if (error.error.detail) {
              errorMessage = {
                detail: error.error.detail,
                code: error.error.code
              }
            } else {
              if (error.status == 500) {
                errorMessage.detail = 'Server Error';
                errorMessage.code = 500;
              } else {
                if (error.status == 429 || error.status == 0) {
                  errorMessage.detail = 'Too many requests, Please try again later';
                  errorMessage.code = 429;
                } else {
                  let message = '';
                  for (const field in error.error) {
                    if (error.error[field]) {
                      message += `${field}: ${error.error[field].concat(' ')}`;
                    }
                  }
                  errorMessage.detail = message;
                  errorMessage.code = 400;
                }
              }
            }
          }
          return throwError(errorMessage);
        })
      );
  }
  private handleBlobError(blob: Blob): Observable<any> {
    return new Observable((observer) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        try {
          const errorObject = JSON.parse(reader.result as string);
          observer.error(errorObject);
        } catch (e) {
          observer.error('Unable to parse error response.');
        }
        observer.complete();
      };
      reader.readAsText(blob);
    });
  }
}
